import _ from 'lodash';
import { ehrAPIBaseService, ehrAPIService } from '../../http-common';

export const fetchPregnancyAndBreastFeedingDataOfFemalePatient =
  async patientId => {
    let response = null;
    try {
      response = await ehrAPIBaseService.get(
        `fhir/search/Observation?subject=${patientId}&code=82810-3,63895-7`
      );
    } catch (e) {
      console.log(
        `Error in fetchPregnancyAndBreastFeedingDataOfFemalePatient`,
        e
      );
    }
    return response;
  };

export const fetchOrganizationDataFromApi = async (type, searchText) => {
  let optionsArrayGP = [];
  let optionsArrayProv = [];
  let optionsArrayOrg = [];

  try {
    // debugger;
    let searchQuery = `search/?_elements=name,type&_sort=name&_type=Organization,Practitioner`;
    if (searchText && !_.isEmpty(searchText)) {
      searchQuery += `&_content:contains=${searchText}`;
    }
    const response = await ehrAPIService.get(searchQuery);

    let organizationProvArray = [];
    let gpArray = [];
    let organizationNotProvAndInsArray = [];

    for (let item of response?.data?.entry) {
      if (item?.resource?.resourceType?.toLowerCase() === 'organization') {
        if (item?.resource?.type?.[0]?.coding?.[0]?.code === 'prov') {
          organizationProvArray.push(item?.resource);
        }
        organizationNotProvAndInsArray.push(item?.resource);
      } else {
        organizationProvArray.push(item?.resource);
        gpArray.push(item?.resource);
      }
    }

    for (let type_ of type) {
      switch (type_) {
        case 'gp':
          for (let item of gpArray) {
            let obj = {
              display: item?.name?.[0]?.text,
              code: `${item?.resourceType}/${item?.id}`,
              data: item,
            };
            optionsArrayGP.push(obj);
          }

          // setGeneralPractitionerOptionsList(optionsArrayGP);
          break;

        case 'prov':
          for (let item of organizationProvArray) {
            let obj = {
              display:
                item?.resourceType?.toLowerCase() === 'organization'
                  ? item?.name
                  : item?.name?.[0]?.text,
              code: `${item?.resourceType}/${item?.id}`,
              data: item,
            };
            optionsArrayProv.push(obj);
          }

          // setPrimaryCareOptionsList(optionsArray);
          break;
        case 'org':
          for (let item of organizationNotProvAndInsArray) {
            let obj = {
              display: item?.name,
              code: `${item?.resourceType}/${item?.id}`,
              data: item,
            };

            optionsArrayOrg.push(obj);
          }
          // setManagingOrganizationOptionsList(optionsArrayOrg);
          break;
        default:
          break;
      }
    }
  } catch (e) {
    console.error(`fhirPatient->getOrganizationAndPractionerData`, e);
  }

  return [optionsArrayGP, optionsArrayProv, optionsArrayOrg];
};
